import React from 'react';
import { MultiSelect } from './multi-select';
import { GAME_GENRES, searchGenres, parseGenres, formatGenres } from '@/data/gameGenres';

interface GenreSelectorProps {
  value: string[];
  onChange: (genres: string[]) => void;
  placeholder?: string;
  maxGenres?: number;
  className?: string;
  disabled?: boolean;
}

export function GenreSelector({
  value,
  onChange,
  placeholder = "Select genres...",
  maxGenres = 50, // Limite très élevée par défaut
  className,
  disabled = false
}: GenreSelectorProps) {
  // Fonction de recherche personnalisée pour les genres
  const searchOptions = (query: string) => {
    return searchGenres(query);
  };

  return (
    <MultiSelect
      options={GAME_GENRES}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search genres..."
      maxItems={maxGenres}
      className={className}
      disabled={disabled}
    />
  );
}

// Fonctions utilitaires pour l'utilisation avec les données de la base de données
export { parseGenres, formatGenres };
